import React from 'react'
import { getDateAndTimeText } from '../../helpers/date/dateHelper'
import { getUserName } from '../../helpers/user/UserHelper'
import parse from 'html-react-parser'

const CommentBlock = ({ comment }) => {

    const extractText = (html) => {
        if (typeof window === 'undefined') return ''; // SSR fallback

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        // doc.querySelectorAll('img').forEach((img) => img.remove());
        const text = doc.body.textContent || '';
        return text
    }

  return (
    <div className='commentsBlock__item'>
        <div className='commentsBlock__item-header'>
            <div className='commentsBlock__item-name'>
                {
                    getUserName({ user: comment.user })
                }
            </div>
            <div className='commentsBlock__item-date'>
                {
                    getDateAndTimeText(comment.date)
                }
            </div>
        </div>
        <div className='commentsBlock__item-text'>
            {
                comment.text ? parse(comment.text) : ''
                // comment.text ? extractText(comment.text) : ''
            }
        </div>
    </div>
  )
}

export default CommentBlock